module.exports = __webpack_public_path__ + "img/logo_cnn.241fca57.png";